import { AloDbBase, IAloDbBaseConstParam } from '@/models/alodb/AloDbBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'

export interface IAloDbUniteMobileConstParam extends IAloDbBaseConstParam {
    UMB_ID:number|null
    UMB_ID_LASTPARENT:number|null
    UMA_ID:number|null
    ENS_ID:number|null
    UMT_ID:number|null
    UMB_KEY:string|null
    UMB_FONCTIONNEL_ON:boolean|null    
    UMB_DATADD:string|null    
    UMB_DATSTOP:string|null    
    UMB_LIBELLE:string|null    
    UMB_NSERIE:string|null    
    UMB_NVERSION:string|null    
    UMB_PMAX:number|null
    CAL_ID:number|null
  }

export class AloDbUniteMobile extends AloDbBase {
        
    public UMB_ID:number|null
    public UMB_ID_LASTPARENT:number|null
    public UMA_ID:number|null
    public ENS_ID:number|null
    public UMT_ID:number|null
    public UMB_KEY:string|null
    public UMB_FONCTIONNEL_ON:boolean|null    
    public UMB_DATADD:Date|null    
    public UMB_DATSTOP:Date|null    
    public UMB_LIBELLE:string|null    
    public UMB_NSERIE:string|null    
    public UMB_NVERSION:string|null    
    public UMB_PMAX:number|null
    public CAL_ID:number|null
    
    constructor({UMB_ID,UMB_ID_LASTPARENT,UMA_ID,ENS_ID,UMT_ID,UMB_KEY,UMB_FONCTIONNEL_ON,UMB_DATADD,UMB_DATSTOP,UMB_LIBELLE,UMB_NSERIE,UMB_NVERSION,UMB_PMAX,CAL_ID,...args }:IAloDbUniteMobileConstParam = {} as IAloDbUniteMobileConstParam) {
        super(args)
        this.UMB_ID = UMB_ID
        this.UMB_ID_LASTPARENT = UMB_ID_LASTPARENT
        this.UMA_ID = UMA_ID        
        this.ENS_ID = ENS_ID   
        this.UMT_ID = UMT_ID   
        this.UMB_KEY = UMB_KEY
        this.UMB_FONCTIONNEL_ON = UMB_FONCTIONNEL_ON
        this.UMB_DATADD = UMB_DATADD == null?null:new Date(UMB_DATADD)        
        this.UMB_DATSTOP = UMB_DATSTOP == null?null:new Date(UMB_DATSTOP)    
        this.UMB_LIBELLE = UMB_LIBELLE   
        this.UMB_NSERIE = UMB_NSERIE
        this.UMB_NVERSION = UMB_NVERSION
        this.UMB_PMAX = UMB_PMAX
        this.CAL_ID = CAL_ID
    }

    static createAloDbUniteMobileArray(datas:any) {
        return new AloBaseArray(AloDbUniteMobile,datas)
    }

    static createAloDbUniteMobileWithDetail(data:any) {
        return new AloDbUniteMobile({...data,detailLoaded:true})
    }
}
